import { render, staticRenderFns } from "./CourseCreate.vue?vue&type=template&id=8a7e31dc&scoped=true"
import script from "./CourseCreate.vue?vue&type=script&lang=js"
export * from "./CourseCreate.vue?vue&type=script&lang=js"
import style0 from "./CourseCreate.vue?vue&type=style&index=0&id=8a7e31dc&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7e31dc",
  null
  
)

export default component.exports